<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <base-crud
          :ref="'profissionalCrud'"
          crudName="Profissionais"
          newText="Novo Profissional"
          :table="table"
          :columns="columns"
          :options="options"
          :endPoint="endPoint"
          :enableAdd="true"
          :enableEdit="true"
          :enableDelete="true"
          :enableView="false"
          :enableReset="false"
          :dataForm="dataForm"
        >
        </base-crud>
      </div>
    </div>
  </div>
</template>

<script>
import BaseCrud from "../../layouts/Base/BaseCrud";

export default {
  data: function () {
    return {
      table: "profissionaisTable",
      showMessageImport: false,
      usersCrud: {},
      pages: [],
      url: "",
      columns: ["id", "nome", "cpf", "empresa_id", "actions"],
      tableData: ["id", "nome", "cpf", "empresa_id"],
      options: {
        filterByColumn: true,
        debounce: 1000,
        filterable: ["id", "nome", "cpf"],
        pagination: { chunk: 10, dropdown: false, nav: "scroll" },
        perPage: 10,
        perPageValues: [10, 25, 50, 100],
        headings: {
          nome: "Nome",
          cpf: "CPF",
          empresa_id: "Empresa",
          actions: "Ações",
        },

        texts: {
          filterBy: "Filtrar",
          defaultOption: "Selecione",
        },
        listColumns: {},
        templates: {
          empresa_id: function (h, row, index) {
            return row.empresa ? row.empresa.nome_fantasia : "Indisponível";
          },
          especialidade_id: function (h, row, index) {
            return row.especialidade
              ? row.especialidade.especialidade
              : "Indisponível";
          },
          id_conselho: function (h, row, index) {
            return row.tipoconselho
              ? row.tipoconselho.conselho
              : "Indisponível";
          },
          id_tipo_profissional: function (h, row, index) {
            return row.tipoprofissional
              ? row.tipoprofissional.tipo_profissional
              : "Indisponível";
          },
        },
        requestFunction: function (data) {
          let requestData = {};

          let query = this.$parent.$parent.$parent.query(data.query);
          requestData.params = data;
          requestData.params.query = "";
          requestData.params.with = [
            "empresa",
            "especialidade",
            "tipoconselho",
            "tipoprofissional",
          ];

          return axios.get(this.url + "?" + query, requestData).catch(
            function (e) {
              this.dispatch("error", e);
            }.bind(this)
          );
        },
      },
      endPoint: "profissionais",
      dataForm: {},
    };
  },
  components: {
    BaseCrud,
  },
  methods: {
    query: function (query) {
      let columns = {
        id: "id",
        nome_profissional: "nome_profissional",
        cpf: "cpf",
        rg: "rg",
        id_tipo_profissional: "tipoprofissional[tipo_profissional]",
        estado: "estado",
        id_conselho: "tipoconselho[conselho]",
        numero_conselho: "numero_conselho",
        especialidade_id: "especialidade[especialidade]",
        empresa_id: "empresa[nome_fantasia]",
      };
      let filters = "";
      $.each(query, function (index, value) {
        filters += columns[index] + "=" + value + "&";
      });
      return filters;
    },
  },
};
</script>

<style scoped>
.VuePagination {
  text-align: center;
}

.uploading-image {
  display: flex;
  border-radius: 10px;
  width: 100px;
  height: 100px;
}
</style>
